import { Component, HostListener, OnInit } from '@angular/core';
import { ActiveOrderDsService } from '@app/core/data-services';
import { NextSetupSubphaseCommandService, PreviousSetupSubphaseCommandService } from '@app/modules/setup-phase/commands';
import { OrderPhaseService } from '@app/shared/components';
import { nav } from '@app/shared/utils';
import { Observable } from 'rxjs';
import { SetupPhaseService } from '../../services/setup-phase/setup-phase.service';
import { QualityAssuranceService } from './quality-assurance.service';
import { ProductionQaCheck, RunSubPhaseType } from 'chronos-core-client';
import { SignatureHandlerService } from '@app/core/services/signature/signature-handler.service';
import { QaCheckType, SignatureConfig } from '@app/shared/models/signature';

@Component({
  selector: 'app-quality-assurance',
  templateUrl: './quality-assurance.component.html',
  styleUrls: ['./quality-assurance.component.scss']
})
export class QualityAssuranceComponent implements OnInit {
  public fields$: Observable<ProductionQaCheck[]>;
  public qualityChecksElectronicSignature = false;

  public backCommandService: PreviousSetupSubphaseCommandService;
  public nextCommandService: NextSetupSubphaseCommandService;
  public isReadOnly = false;
  public signatureConfig = {} as SignatureConfig;
  private isNextButtonEnabled = false;
  public isSigantureActive = false;

  constructor(
    private qualityAssuranceService: QualityAssuranceService,
    private activeOrderDsService: ActiveOrderDsService,
    private setupPhaseService: SetupPhaseService,
    private setupFooterService: OrderPhaseService,
    private signatureHandlerService: SignatureHandlerService
  ) {}

  public ngOnInit(): void {
    const productionOrderId = this.activeOrderDsService.getActiveOrderId();

    this.fields$ = this.qualityAssuranceService.getQACheckFields(productionOrderId);

    this.setCommands();

    this.qualityChecksElectronicSignature = this.signatureHandlerService.isQualityCheckSignatureEnabled();
    if (this.qualityChecksElectronicSignature) {
      this.signatureConfig = {
        isSignatureFeatureEnabled: this.qualityChecksElectronicSignature,
        qaCheckType: QaCheckType.Setup
      };

      // check if the signature is present and set the next button state accordingly
      this.signatureHandlerService.signatureIsPresent$.subscribe((signatureIsPresent) => {
        this.nextCommandService.enabled = signatureIsPresent && this.isNextButtonEnabled;
      });
    }

    this.isReadOnly = this.signatureHandlerService.setReadOnlyState();

  }

  @HostListener('document:click', ['$event'])
  public onDocumentClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    if (!target.closest('.signature-container') && this.isSigantureActive) {
      this.isSigantureActive = false;
    }
  }

  public onFormValidityChange(isQaCheckValid: boolean): void {
    this.isNextButtonEnabled = isQaCheckValid;

    // Check if the signature is enabled and if the signature is present
    // If the signature is enabled, the next button should be enabled only if the signature is present
    if(this.qualityChecksElectronicSignature) {
      const hasActiveSignature = this.signatureHandlerService.isSignaturePresent();
      this.nextCommandService.enabled = isQaCheckValid && hasActiveSignature;
    } else {
      this.nextCommandService.enabled = isQaCheckValid;
    }
  }

  public setActiveSignature() {
    this.isSigantureActive = true;
  }

  private setCommands(): void {
    this.backCommandService = new PreviousSetupSubphaseCommandService(this.setupFooterService);
    this.backCommandService.setNavigationParams(nav.routes.setupParameters);

    this.nextCommandService = new NextSetupSubphaseCommandService(this.setupFooterService);
    this.nextCommandService.setNavigationParams(RunSubPhaseType.SetupMaterialWaste, nav.routes.wasteAssignment);

    this.setupPhaseService.setSetupCommands(this.backCommandService, this.nextCommandService);
  }
}
